import { FaSearchLocation, FaProjectDiagram, FaTools, FaCogs, FaCheckDouble, FaHeadset } from 'react-icons/fa';
import images from './images';

const process = [
    {
        id: 1,
        image: images.step1,
        icon: <FaSearchLocation />, // Site Assessment Icon
        title: 'Site Assessment',
        content: 'We conduct a site evaluation to identify vulnerabilities and recommend the best solutions.',
    },
    {
        id: 2,
        image: images.step2,
        icon: <FaProjectDiagram />, // System Design Icon
        title: 'System Design',
        content: 'We create a tailored security plan, ensuring all areas are covered with the right cameras, sensors, and alarms.',
    },
    {
        id: 3,
        image: images.step3,
        icon: <FaTools />, // Equipment Installation Icon
        title: 'Equipment Installation',
        content: 'Our team installs state-of-the-art cameras, alarms, and monitoring systems with efficiency.',
    },
    {
        id: 4,
        image: images.step4,
        icon: <FaCogs />, // System Configuration Icon
        title: 'System Configuration',
        content: 'We set up your system, ensuring all devices are interconnected and functioning with user-friendly controls.',
    },
    {
        id: 5,
        image: images.step5,
        icon: <FaCheckDouble />, // Testing & Training Icon
        title: 'Testing & Training',
        content: 'We perform rigorous testing and train your team to use the system effectively for maximum security.',
    },
    {
        id: 6,
        image: images.step6,
        icon: <FaHeadset />, // Continuous Support Icon
        title: 'Continuous Support',
        content: 'We offer ongoing maintenance and support to keep your security system running at peak performance.',
    },
];

export default process;